/** Its own module so tests can replace it — jsdom will not do a real reload. */
const reloadDocument = () => {
  window.location.reload();
};

export default reloadDocument;
